import { lazy, Suspense } from 'react';
import { useLocation } from 'react-router-dom';

const ProductListPage = lazy(() =>
  import('../features/products/ProductListPage').then((module) => ({
    default: module.ProductListPage,
  })),
);
const ProductDetailPage = lazy(() =>
  import('../features/products/ProductDetailPage').then((module) => ({
    default: module.ProductDetailPage,
  })),
);
const ProductFormPage = lazy(() =>
  import('../features/products/ProductFormPage').then((module) => ({
    default: module.ProductFormPage,
  })),
);
const TagsPage = lazy(() =>
  import('../features/settings/TagsPage').then((module) => ({
    default: module.TagsPage,
  })),
);
const UsersPage = lazy(() =>
  import('../features/settings/UsersPage').then((module) => ({
    default: module.UsersPage,
  })),
);
const GeneralSettingsPage = lazy(() =>
  import('../features/settings/GeneralSettingsPage').then((module) => ({
    default: module.GeneralSettingsPage,
  })),
);
const CostsSettingsPage = lazy(() =>
  import('../features/settings/CostsSettingsPage').then((module) => ({
    default: module.CostsSettingsPage,
  })),
);
const RackSettingsPage = lazy(() =>
  import('../features/settings/RackSettingsPage').then((module) => ({
    default: module.RackSettingsPage,
  })),
);
const MapPage = lazy(() =>
  import('../features/map/MapPage').then((module) => ({
    default: module.MapPage,
  })),
);
const OrdersPage = lazy(() =>
  import('../features/orders/OrdersPage').then((module) => ({
    default: module.OrdersPage,
  })),
);
const NewOrderForm = lazy(() =>
  import('../features/orders/NewOrderForm').then((module) => ({
    default: module.NewOrderForm,
  })),
);
const OrderDetailPage = lazy(() =>
  import('../features/orders/OrderDetailPage').then((module) => ({
    default: module.OrderDetailPage,
  })),
);
const ExecutedOrderMovesPage = lazy(() =>
  import('../features/orders/ExecutedOrderMovesPage').then((module) => ({
    default: module.ExecutedOrderMovesPage,
  })),
);
const DashboardPage = lazy(() =>
  import('../features/dashboard/DashboardPage').then((module) => ({
    default: module.DashboardPage,
  })),
);
const LogatecMapPage = lazy(() =>
  import('../features/logatec/LogatecMapPage').then((module) => ({
    default: module.LogatecMapPage,
  })),
);
const LogatecProductListPage = lazy(() =>
  import('../features/logatec/LogatecProductListPage').then((module) => ({
    default: module.LogatecProductListPage,
  })),
);
const LogatecProductDetailPage = lazy(() =>
  import('../features/logatec/LogatecProductDetailPage').then((module) => ({
    default: module.LogatecProductDetailPage,
  })),
);
const LogatecProductFormPage = lazy(() =>
  import('../features/logatec/LogatecProductFormPage').then((module) => ({
    default: module.LogatecProductFormPage,
  })),
);
const LogatecMapSettingsPage = lazy(() =>
  import('../features/logatec/LogatecMapSettingsPage').then((module) => ({
    default: module.LogatecMapSettingsPage,
  })),
);

function Loading() {
  return <div className="page-loading">Nalaganje …</div>;
}

export function ProductListRoute() {
  const location = useLocation();
  return (
    <Suspense fallback={<Loading />}>
      <ProductListPage key={location.search} />
    </Suspense>
  );
}

export function ProductDetailRoute() {
  return (
    <Suspense fallback={<Loading />}>
      <ProductDetailPage />
    </Suspense>
  );
}

export function ProductFormRoute() {
  return (
    <Suspense fallback={<Loading />}>
      <ProductFormPage />
    </Suspense>
  );
}

export function TagsRoute() {
  return (
    <Suspense fallback={<Loading />}>
      <TagsPage />
    </Suspense>
  );
}

export function UsersRoute() {
  return (
    <Suspense fallback={<Loading />}>
      <UsersPage />
    </Suspense>
  );
}

export function GeneralSettingsRoute() {
  return (
    <Suspense fallback={<Loading />}>
      <GeneralSettingsPage />
    </Suspense>
  );
}

export function CostsSettingsRoute() {
  return (
    <Suspense fallback={<Loading />}>
      <CostsSettingsPage />
    </Suspense>
  );
}

export function RackSettingsRoute() {
  return (
    <Suspense fallback={<Loading />}>
      <RackSettingsPage />
    </Suspense>
  );
}

export function MapRoute() {
  return (
    <Suspense fallback={<Loading />}>
      <MapPage />
    </Suspense>
  );
}

export function OrdersRoute() {
  return (
    <Suspense fallback={<Loading />}>
      <OrdersPage />
    </Suspense>
  );
}

export function NewOrderRoute() {
  return (
    <Suspense fallback={<Loading />}>
      <NewOrderForm />
    </Suspense>
  );
}

export function OrderDetailRoute() {
  return (
    <Suspense fallback={<Loading />}>
      <OrderDetailPage />
    </Suspense>
  );
}

export function ExecutedOrderMovesRoute() {
  return (
    <Suspense fallback={<Loading />}>
      <ExecutedOrderMovesPage />
    </Suspense>
  );
}

export function DashboardRoute() {
  return (
    <Suspense fallback={<Loading />}>
      <DashboardPage />
    </Suspense>
  );
}

export function LogatecMapRoute() {
  return (
    <Suspense fallback={<Loading />}>
      <LogatecMapPage />
    </Suspense>
  );
}

export function LogatecProductListRoute() {
  return (
    <Suspense fallback={<Loading />}>
      <LogatecProductListPage />
    </Suspense>
  );
}

export function LogatecProductDetailRoute() {
  return (
    <Suspense fallback={<Loading />}>
      <LogatecProductDetailPage />
    </Suspense>
  );
}

export function LogatecProductFormRoute() {
  return (
    <Suspense fallback={<Loading />}>
      <LogatecProductFormPage />
    </Suspense>
  );
}

export function LogatecMapSettingsRoute() {
  return (
    <Suspense fallback={<Loading />}>
      <LogatecMapSettingsPage />
    </Suspense>
  );
}
